import { Settings } from '@streamr/tv-engine/~/settings';
import { AppAudioDecoder } from './AppAudioDecoder';
import { OpusAudioDecoder } from './OpusAudioDecoder';
/**
 * Selects an audio decoder by codec string.
 *
 * Opus path (default): inline `@streamr/opus` WASM decoder running in the
 * calling worker — no nested worker, no Comlink per-frame hop. Used on every
 * browser.
 *
 * AAC (RTMP composite) path: WebCodecs `AudioDecoder` via `AppAudioDecoder`.
 * Out of scope for the SAB migration; retained to keep the RTMP rebroadcast
 * path working as-is.
 */
export async function createAudioDecoder(trackId, codec = Settings.audioCodec) {
    if (codec === Settings.audioCodec) {
        return new OpusAudioDecoder(trackId, codec);
    }
    return new AppAudioDecoder(trackId, codec);
}
